<template>
  <div class="data-analysis-outer">
    <BlockTitle title="资产用途" />
    <div id="chartDom" class="chart-canvas" />
  </div>
</template>

<script>
import BlockTitle from '@/views/public_0983cc/tradeData/components/public/BlockTitle.vue'
import {
  data_v2_rate
} from '@/api/portal'
import { mapGetters } from 'vuex'

export default {
  components: {
    BlockTitle
  },
  data() {
    return {
      chartInstance: null,
      chartData: []
    }
  },
  computed: {
    ...mapGetters(['selectLocId']),
    chartDom() {
      return document.getElementById('chartDom')
    },
    charOption() {
      return {
        grid: {
          height:'65%',
          left: '75px'  // 设置图表左边距离容器左边的偏移量
        },
        xAxis: {
          type: 'category',
          data: ['农业', '商业', '居住', '工业', '建设', '自用', '其他'],
          axisLabel: {
            color: '#FFFFFF'  // 设置X轴刻度值的颜色
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#FFFFFF'  // 设置X轴刻度值的颜色
          }
        },
        tooltip: {
            backgroundColor:'rgba(51,51,51,.8)',
            textStyle: {
              color: '#fff',
            },
            borderColor: 'transparent',
            formatter: (params) => {
                return `${params.marker}${params.name}
                <br/>
                <span style="margin:0 6px"></span>数量：${params.value}
                `;
            },
          },
        series: [
          {
            data: [
              {
                value: 66736,
                itemStyle: {
                  color: '#7EEFFE'  // 设置柱形颜色为蓝色
                }
              },
              
              {
                value: 2235,
                itemStyle: {
                  color: '#fac858'  // 设置柱形颜色为黄色
                }
              },
              {
                value: 1056,
                itemStyle: {
                  color: '#409EFF'  // 设置柱形颜色为蓝色
                }
              },
              {
                value: 352,
                itemStyle: {
                  color: '#909399'  // 设置柱形颜色为灰色
                }
              },
              {
                value: 1824,
                itemStyle: {
                  color: '#fc8452'  // 设置柱形颜色为橙色
                }
              },
              {
                value: 22061,
                itemStyle: {
                  color: '#9a60b4'  // 设置柱形颜色为紫色
                }
              },
              {
                value: 12654,
                itemStyle: {
                  color: '#9DCA78'  // 设置柱形颜色为绿色
                }
              }
            ],
            type: 'bar',
            /* label: {
              show: true,  // 显示标签
              position: 'top',  // 标签位置在柱形的顶部
              color: '#7EEFFE',  // 文本颜色
              padding: 5,  // 文本内边距
              borderRadius: 3  // 边框圆角
            } */
          }
        ]
      }
    }
  },
  watch: {
    async selectLocId() {
      await this.getRate()
      this.chartInstance.setOption(this.charOption)
    }
  },
  created() {

  },
  async mounted() {
    await this.getRate()
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.chartDom)
      this.chartInstance.setOption(this.charOption)
    },
    // 获取竞价率及溢价率
    async getRate() {
      const { data } = await data_v2_rate({
        locId: this.selectLocId
      })
      this.chartData = data
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-canvas{
  width: 100%;
  height: 250px;
}
</style>
